import * as React from 'react'
import { FlatButton } from 'material-ui'
import '../styles/StartingPage.scss'
import { Link } from 'react-router-dom'
import { RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'
import { StoreState } from '../reducers'
import { DEFAULT_ROUTE } from '../constants/routes'

import { ActionType as StoreAction, Actions as StoreActions } from '../actions/store'
import { ONBOARDING_URL } from '../config/onboarding'
import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import { StringResources } from '../localization/StringResources';
import { Strings } from '../localization';

interface StartingPageProps {
  isSigned: boolean
  routePush: (location: string) => RouterAction
  cleanState: () => StoreAction
}


export class StartingPage extends React.Component<StartingPageProps, {}> {

  constructor(props: any) {
    super(props)
  }

  componentWillMount() {
    if (this.props.isSigned) {
      this.props.routePush(DEFAULT_ROUTE)
    } else {
      this.props.cleanState()
    }
  }

  render() {
    return (
      <BaseContainer pageName={EventType.SPLASH_SCREEN} classname='starting-page'>
        <div className="sign-in-button" >
          <Link to="/signin" >
            <FlatButton
              
              label={StringResources.getString(Strings.StartingPage.Buttons.SignIn.label)}
              className="bflatbutton" 
            />
          </Link>
          <div className="text"><a href={ONBOARDING_URL} target="_blank">{StringResources.getString(Strings.StartingPage.Title)}</a></div>
        </div>
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    isSigned: state.auth.isSigned
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    cleanState: () => dispatch(StoreActions.cleanAll())
  }
}

export const StartingPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StartingPage)



// WEBPACK FOOTER //
// ./src/containers/StartingPage.tsx